import moment from 'moment'
import React from 'react'
import Countdown from 'react-countdown'

const endTime = '11 November 2022';
const end_time = '11 November 2022';

const CountDown = () => {
    return (
        <div className='header-top'>
            <div className='subscribe-text'>
                {
                    moment(moment()).isBefore(endTime) ? 'Platform access ending in' : 'Your Subscription has expired!'
                }
                {/* 10 days : 08 Hrs */}

                <div className='d-flex align-items-center justify-content-around'>
                    {
                        end_time && endTime &&
                        <>
                            {/* 
                              start_time -> Only time component of workshop start data and time 
                              startTime -> both date and time component of workshop start date and time
                          */}
                            {
                                // current time is less than workshop start date and time then start countdown timer
                                moment(moment()).isBefore(endTime) ?
                                    <>
                                        <Countdown
                                            date={endTime}
                                            renderer={
                                                ({ days, hours, minutes, seconds, completed }) => {
                                                    if (completed) {
                                                        return <>
                                                            {/* <span>Your Subscription has expired!</span> */}
                                                            <div className='timer-box'>
                                                                <span>00</span>
                                                                <span>Day</span>
                                                            </div>
                                                            <div className='timer-box'>
                                                                <span>00</span>
                                                                <span>Hrs</span>
                                                            </div>
                                                            <div className='timer-box'>
                                                                <span>00</span>
                                                                <span>Mins</span>
                                                            </div>
                                                        </>
                                                    } else {
                                                        // Timer running here
                                                        return <>
                                                            {/* <span>Platform access ending in</span> */}
                                                            <div className='timer-box'>
                                                                <span>{days}</span>
                                                                <span>{days > 1 ? 'Days' : 'Day'}</span>
                                                            </div>
                                                            <div className='timer-box'>
                                                                <span>{hours}</span>
                                                                <span>Hrs</span>
                                                            </div>
                                                            <div className='timer-box'>
                                                                <span>{minutes}</span>
                                                                <span>Mins</span>
                                                            </div>
                                                        </>
                                                    }
                                                }
                                            }
                                        />
                                    </>
                                    :
                                    <>
                                        {/* <span>Your Subscription has expired!</span> */}
                                        <div className='timer-box'>
                                            <span>00</span>
                                            <span>Day</span>
                                        </div>
                                        <div className='timer-box'>
                                            <span>00</span>
                                            <span>Hrs</span>
                                        </div>
                                        <div className='timer-box'>
                                            <span>00</span>
                                            <span>Mins</span>
                                        </div>
                                    </>
                            }

                        </>
                    }
                </div>
                {/* <span className='d-md-inline d-block ml-1'>(10th Nov 11:59 PM)</span> */}
                <a href='https://rzp.io/l/quarterlyrenewal'>Renew Now</a>
            </div>
        </div>
    )
}

export default CountDown